





































































































































































































import {
  ActivityHistoryType,
  DrivewealthAccountManagementType,
  DrivewealthAccountSummary,
  DrivewealthTransactionUnit,
  InstrumentDetail,
  OrderUnits
} from "@/shared/types";
import { Component, Prop, Vue, Watch } from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import RiskDisclaimer from "@/shared/components/investments/drivewealth/RiskDisclaimer.vue";
import SharePriceTable from "@/employee/components/investments/drivewealth/SharePriceTable.vue";
import { formatCurrency, roundCurrencyUSD } from "@/shared/currency";
import _ from "lodash";
import * as RouteNames from "@/employee/route-names";
import * as SharedRoutes from "@/shared/route-names";
import { Validator } from "vee-validate";
import { useUserStore } from "@/shared/store/user";
import { useNotifierStore } from "@/shared/store/notifier";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useDrivewealthSweepStore } from "@/shared/store/drivewealthSweep";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { Location } from "vue-router";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

const askToLiquidateIfSellingFraction = 0.9;
const askToLiquidateIfLeavingLessThan = 1; // USD
const MutualFund = "MUTUAL_FUND";

export interface RequestOrderData {
  shouldSellAll: boolean;
  amountUsd: number;
  isSubmitting: boolean;
  confirmedSweep: boolean;
}

@Component({
  computed: {
    DrivewealthTransactionUnit () {
      return DrivewealthTransactionUnit;
    },
  },
  components: {
    GenericLoadingSpinner,
    SharePriceTable,
    RiskDisclaimer,
  }
})
export default class RequestSellPage extends Vue {
  @Prop()
  symbol: string;

  @Prop({ required: false })
  doubleConfirm: boolean;

  @Prop()
  accountId: number;

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  data?: RequestOrderData = null;
  shouldSellAllConfirmation = true; // value for the doubleConfirm radio button
  loadedStockSymbol?: string = null;
  adjustToSellAll = false;
  selectedTransactionUnit = DrivewealthTransactionUnit.ByAmount;
  amountShares = 0;

  formatCurrency = formatCurrency;

  $validator: Validator;
  notifierStore = useNotifierStore();
  featureFlagStore = useFeatureFlagStore();
  drivewealthStore = useDrivewealthStore();
  drivewealthSweepStore = useDrivewealthSweepStore();
  userStore = useUserStore();
  custodianSettingsStore = useCustodianSettingsStore();

  created (): void {
    if (this.accountId) {
      this.drivewealthStore.getAccountSummaryV2({ force: true, username: this.username, partnerId: this.partnerId, dwAccountId: this.accountId });
      this.drivewealthStore.loadPendingActivityByAccount({ force: true, accountId: this.accountId, username: this.username, partnerId: this.partnerId });
    }
    this.drivewealthStore.loadHsaBalanceAndThreshold({ force: true, accountId: this.accountId, username: this.username, partnerId: this.partnerId });
    this.drivewealthSweepStore.getSweep({ username: this.username, partnerId: this.partnerId });
    this.userStore.loadPartnerSettings();
    this.onCreatedAndLoaded();
  }

  get portalFunctionalityDisabled (): boolean {
    return this.custodianSettingsStore.portalFunctionalityDisabled;
  }

  get disableSellButton (): boolean {
    if (this.portalFunctionalityDisabled) {
      return true;
    }

    if (this.isLoaded) {
      const accountSummary = this.accountSummaryV2;
      let holdingBalance = 0;
      if (accountSummary.accountManagementType === DrivewealthAccountManagementType.RiaManaged) {
        holdingBalance = _.sumBy(accountSummary.holdings, "marketValue");
        holdingBalance = holdingBalance + accountSummary.cashBalance;
      } else {
        holdingBalance = accountSummary.holdings.find(x => x.stockSymbol === this.symbol).marketValue;
      }
      const pendingOrders = this.drivewealthStore.pendingActivityById(this.accountId).pendingOrders;
      const pendingSell = pendingOrders.filter(x => x.type === ActivityHistoryType.Sell && x.stockSymbol === this.symbol).reduce((sum, current) => sum + current.dollarAmount, 0);
      const formattedHoldingBalance = (Number(holdingBalance.toFixed(2)) * 100).toFixed(0);
      const formattedPendingSell = (Number(pendingSell.toFixed(2)) * 100).toFixed(0);

      const sellAmount = this.selectedTransactionUnit === DrivewealthTransactionUnit.ByShare ?
          (this.amountShares * this.instrumentDetail.currentPrice) :
          this.data.amountUsd;

      return sellAmount > (Number(formattedHoldingBalance) - Number(formattedPendingSell)) / 100;
    }

    return false;
  }

  get accountSummaryV2 (): DrivewealthAccountSummary {
    return this.drivewealthStore.accountSummaryById(this.accountId);
  }

  get isLoading (): boolean {
    return !this.isLoaded;
  }

  get isLoaded (): boolean {
    const accountSummaryV2Loaded = this.drivewealthStore.accountSummaryV2Loaded(this.accountId);

    const instrumentDataLoaded = this.isManagedAccount ? true : this.drivewealthStore.instrumentDataIsLoaded(this.symbol);

    return this.drivewealthStore.isHsaBalanceAndThresholdLoaded(this.accountId) &&
      this.drivewealthSweepStore.sweepLoaded &&
      accountSummaryV2Loaded &&
      !!this.data &&
      instrumentDataLoaded;
  }

  @Watch("selectedTransactionUnit")
  resetInputOnUnitChange (): void {
    this.amountShares = 0;
    this.data.amountUsd = 0;
    this.shouldSellAll = false;
  }

  get selectDrivewealthTransactionUnitEnabled (): boolean {
    return this.featureFlagStore.flags.bend24349EnableBuySellByShare &&
        !this.isManagedAccount;
  }

  get heading (): string {
    return this.drivewealthStore.instrumentHeading(this.symbol, this.accountId);
  }

  get subheading (): string {
    return this.drivewealthStore.instrumentSubheading(this.symbol, this.accountId);
  }

  get isManagedAccount (): boolean {
    return this.drivewealthStore.isAccountManagementType(
      DrivewealthAccountManagementType.RiaManaged, this.accountId);
  }

  @Watch("symbol")
  getData (): void {
    if (this.data && this.loadedStockSymbol !== this.symbol) {
      this.data = null; // the symbol changed, gotta start over!
      this.onCreatedAndLoaded(); // N.B. Setting data = null stops this from being infinite loop
    }

    this.loadedStockSymbol = this.symbol;
    this.data = {
      shouldSellAll: false,
      amountUsd: 0,
      isSubmitting: false,
      confirmedSweep: false,
    };
  }

  @Watch("isLoaded")
  onCreatedAndLoaded (): void {
    if (!this.isManagedAccount) {
      this.drivewealthStore.loadInstrumentData(this.symbol, this.accountId,
          { username: this.username, partnerId: this.partnerId });
    }

    this.getData();
  }

  get numberOfSharesHeld (): number {
    return this.drivewealthStore.availableForTradingQty(this.symbol, this.accountId);
  }

  get hasNotConfirmedSweep (): boolean {
    return this.drivewealthSweepStore.sweepIsActive && !this.data.confirmedSweep;
  }

  get pendingLiquidation (): boolean {
    const pendingActivity = this.drivewealthStore.pendingActivityById(this.accountId);

    return this.isManagedAccount && pendingActivity.hasPendingManagedLiquidation;
  }

  get disabledAll (): boolean {
    return this.hasNotConfirmedSweep || this.pendingLiquidation || this.userStore.partnerDisableInvestmentActivity;
  }

  get amountHeldUsd (): number {
    if (this.isManagedAccount) {
      return this.drivewealthStore.amountHeld(this.symbol, this.accountId) + this.drivewealthStore.cashAvailableForWithdrawal(this.accountId);
    }

    return this.drivewealthStore.amountHeld(this.symbol, this.accountId);
  }

  get sellAmountEqualsAmountHeld (): boolean {

    const sellAmount = this.selectedTransactionUnit === DrivewealthTransactionUnit.ByShare ?
        (this.amountShares * this.instrumentDetail.currentPrice) :
        this.data.amountUsd;

    return this.amountHeldUsd === roundCurrencyUSD(sellAmount);
  }

  get liquidate (): boolean {
    if (this.doubleConfirm) {
      return this.shouldSellAllConfirmation;
    }

    return this.data.shouldSellAll || this.sellAmountEqualsAmountHeld;
  }

  get shouldSellAll (): boolean {
    return this.data.shouldSellAll;
  }

  set shouldSellAll (value) {
    if (value && value !== this.data.shouldSellAll) {
      this.data.amountUsd = this.amountHeldUsd;
      this.amountShares = this.numberOfSharesHeld;
    }
    this.data.shouldSellAll = value;
  }

  get instrumentDetail (): InstrumentDetail {
    return this.drivewealthStore.instrumentDetailBySymbol(this.symbol);
  }

  @Watch("data.shouldSellAll")
  resetMutualFundAmountValidation (newValue): void {
    if (!this.instrumentDetail || (this.instrumentDetail.fundType !== MutualFund)) {
      return;
    }

    if (newValue === false) {
      this.adjustToSellAll = false;
    }
  }

  @Watch("data.amountUsd")
  checkMutualFundAmountValidation (): void {
    if (!this.instrumentDetail || (this.instrumentDetail.fundType !== MutualFund)) {
      return;
    }

    let fractionSelling = 0;
    if (this.selectedTransactionUnit === DrivewealthTransactionUnit.ByAmount) {
      fractionSelling = this.data.amountUsd / this.amountHeldUsd;
    } else {
      fractionSelling = (this.amountShares * this.instrumentDetail.currentPrice) / this.amountHeldUsd;
    }
    if (fractionSelling > askToLiquidateIfSellingFraction && fractionSelling < 1) {
      this.data.amountUsd = this.amountHeldUsd;
      this.amountShares = this.numberOfSharesHeld;
      this.$nextTick(() => {
        this.adjustToSellAll = true;
        this.data.shouldSellAll = true;
      });
    }
  }

  get units (): OrderUnits {
    return this.liquidate ? "SHARES" : "USD";
  }

  get amount (): number {
    return this.liquidate ? this.numberOfSharesHeld : this.data.amountUsd;
  }

  get sweepRoute (): string {
    if (this.accountId) {
      return RouteNames.DrivewealthSweepV2;
    }

    return RouteNames.DrivewealthSweep;
  }

  onAcknowledgedSweepIsActive (): void {
    this.data.confirmedSweep = true;
  }

  navigateBack (): void {
    window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
  }

  get routeToEmployerInvestmentsV2 (): Location {
    const query = (this.username) ? { username: this.username } : undefined;
    return {
      name: SharedRoutes.DrivewealthInvestmentAccountV2,
      params: { accountId: `${this.accountId}`, partnerId: `${this.partnerId}` },
      query
    };
  }

  navigateOnSaleRequested (): void {
    if (this.userStore.isEmployerPortal) {
      this.$router.push(this.routeToEmployerInvestmentsV2);
    } else {
      this.$router.push({
        name: SharedRoutes.DrivewealthInvestmentAccountV2,
        params: { accountId: `${this.accountId}`},
        query: { force: "true" }
      });
    }
  }

  get amountValidator (): any {
    return {
      required: true,
      decimal: 2,
      min_value_usd: 0.01,
      max_value_usd: this.amountHeldUsd
    };
  }

  get sharesValidator (): any {
    return {
      required: true,
      decimal: 6,
      min_value: 0.1,
      max_value: this.numberOfSharesHeld
    };
  }

  onConfirm (): void {
    if (this.data.isSubmitting) {
      return;
    }

    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }

      this.data.isSubmitting = true;
      this.onConfirmAndValidated();
    });
  }

  onCancel (): void {
    this.navigateBack();
  }

  onConfirmAndValidated (): void {
    if (this.portalFunctionalityDisabled) {
      return;
    }

    if (!this.liquidate) {
      let formattedAmount = 0;
      const sellAmount = this.selectedTransactionUnit === DrivewealthTransactionUnit.ByShare ?
          (this.amountShares * this.instrumentDetail.currentPrice).toFixed(2) :
          this.data.amountUsd.toFixed(2);
      formattedAmount = parseFloat(sellAmount);
      const amountLeft = this.amountHeldUsd - formattedAmount;
      const fractionSelling = formattedAmount / this.amountHeldUsd;
      if (amountLeft < askToLiquidateIfLeavingLessThan || fractionSelling > askToLiquidateIfSellingFraction) {
        if (this.accountId) {
          this.$router.push({
            name: RouteNames.DrivewealthSellInstrumentConfirmV2,
            params: { symbol: this.symbol, accountId: `${this.accountId}` }
          });
        } else {
          this.$router.push({
            name: RouteNames.DrivewealthSellInstrumentConfirm,
            params: { symbol: this.symbol }
          });
        }

        this.data.isSubmitting = false;
        return;
      }
    }

    this.sendRequest();
  }

  onConfirmSubmit (): void {
    if (this.data.isSubmitting) {
      return;
    }

    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }

      this.data.isSubmitting = true;
      this.sendRequest();
    });
  }

  sendRequest (): void {
    let orderPromise: Promise<any>;

    if (this.isManagedAccount) {
      let sellAmount = this.data.amountUsd;

      if (this.selectedTransactionUnit === DrivewealthTransactionUnit.ByShare) {
        sellAmount = roundCurrencyUSD(this.amountShares * this.instrumentDetail.currentPrice);
      } else if (this.liquidate) {
        sellAmount = undefined;
      }

      if (this.userStore.isEmployerPortal) {
        orderPromise = this.drivewealthStore.servicerCreateManagedRedemptionByAccount({
          data: {
            amount: sellAmount,
            isLiquidation: this.liquidate,
            forUser: this.username
          },
          accountId: this.accountId,
          partnerId: this.partnerId
        });
      } else {
        orderPromise = this.drivewealthStore.createManagedRedemptionByAccount({
          data: {
            amount: sellAmount,
            isLiquidation: this.liquidate,
          },
          accountId: this.accountId
        });
      }
    } else {
      let sellAmount = this.data.amountUsd;

      if (this.selectedTransactionUnit === DrivewealthTransactionUnit.ByShare) {
        sellAmount = roundCurrencyUSD(this.amountShares * this.instrumentDetail.currentPrice);
      } else if (this.liquidate) {
        sellAmount = this.numberOfSharesHeld;
      }

      if (this.userStore.isEmployerPortal) {
        orderPromise = this.drivewealthStore.servicerCreateOrderRequestByAccount({
          data: {
            side: "SELL",
            units: this.units,
            stockSymbol: this.symbol,
            amount: sellAmount,
          },
          username: this.username,
          accountId: this.accountId,
          partnerId: this.partnerId
        });
      } else {
        orderPromise = this.drivewealthStore.createOrderRequestByAccount({
          data: {
            side: "SELL",
            units: this.units,
            stockSymbol: this.symbol,
            amount: sellAmount
          },
          accountId: this.accountId
        });
      }
    }

    orderPromise.then(() => {
      let amountMessage = `Sale of ${formatCurrency(this.data.amountUsd)} ${this.symbol} sent`;
      if (this.liquidate) {
        amountMessage = `Sale of all ${this.symbol} holdings sent`;
      } else if (this.selectedTransactionUnit === DrivewealthTransactionUnit.ByShare) {
        amountMessage = `Sale of ${this.amountShares} shares ${this.symbol} sent`;
      }
      const message = amountMessage
        + "<div>It may take up to 2 minutes for the order to display.</div>";
      this.notifierStore.setSuccess(message);
      this.navigateOnSaleRequested();
    }).finally(() => {
      this.data.isSubmitting = false;
    });
  }
}
